import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  label,
  Input,
  Row,
  Col,
  Button,
} from "reactstrap";

const AmendBookingModal = ({ isOpen, toggle }) => {
  const [formData, setFormData] = useState({
    reference: "CYP-188280",
    airport: "Heathrow",
    product: "Instant Meet & Greet",
    departureDate: "2024-12-25",
    departureTime: "05:00",
    arrivalDate: "2024-12-31",
    arrivalTime: "15:00",
    title: "Mr.",
    firstName: "Gavin",
    surname: "Shepherd",
    contactMobile: "07413493281",
    emailAddress: "daria2598@icloud.com",
    address: "37 Vesta House, Liberty Bridge Road",
    postCode: "E201AN",
    customerLogin: "daria2598@icloud.com",
    loginPassword: "d0d0f042",
    departTerminal: "Terminal 2",
    departFlight: "TBC",
    returnTerminal: "Terminal 2",
    arrivalFlight: "SK805",
    make: "BMW",
    model: "330E",
    colour: "Grey",
    registration: "GN70RRV",
    sendCustomerEmail: true,
    sendCompanyEmail: true,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    toggle(); 
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}   className="fullscreen-modal"
    contentClassName="fullscreen-modal-content" >
      <ModalHeader toggle={toggle}>Amend Booking</ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          <Row>
            <Col md="2">
              <FormGroup>
                <label for="reference">Reference *</label>
                <Input
                  type="text"
                  id="reference"
                  name="reference"
                  value={formData.reference}
                  onChange={handleChange}
                  required
                  disabled
                />
              </FormGroup>
            </Col>
            <Col md="2">
              <FormGroup>
                <label for="airport">Airport *</label>
                <Input
                  type="select"
                  id="airport"
                  name="airport"
                  value={formData.airport}
                  onChange={handleChange}
                  required
                >
                  <option>Heathrow</option>
                  <option>Gatwick</option>
                  <option>Manchester</option>
                </Input>
              </FormGroup>
            </Col>
            <Col md="2">
              <FormGroup>
                <label for="product">Product *</label>
                <Input
                  type="select"
                  id="product"
                  name="product"
                  value={formData.product}
                  onChange={handleChange}
                  required
                >
                  <option>Instant Meet & Greet</option>
                  <option>Park & Ride</option>
                </Input>
              </FormGroup>
            </Col>
            <Col md="2">
              <FormGroup>
                <label for="departureDate">Departure Date *</label>
                <Input
                  type="date"
                  id="departureDate"
                  name="departureDate"
                  value={formData.departureDate}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
            </Col>
            
            <Col md="1">
              <FormGroup>
                <label for="departureTime">Time *</label>
                <Input
                  type="time"
                  id="departureTime"
                  name="departureTime"
                  value={formData.departureTime}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
            </Col>
            <Col md="2">
              <FormGroup>
                <label for="arrivalDate">Arrival Date *</label>
                <Input
                  type="date"
                  id="arrivalDate"
                  name="arrivalDate"
                  value={formData.arrivalDate}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
            </Col>
            <Col md="1">
              <FormGroup>
                <label for="arrivalTime">Time *</label>
                <Input
                  type="time"
                  id="arrivalTime"
                  name="arrivalTime"
                  value={formData.arrivalTime}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
          
           
          </Row>
          <Row>
           
           
          </Row>
          <Row>
            <Col md="3">
              <FormGroup>
                <label for="title">Title *</label>
                <Input
                  type="select"
                  id="title"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  required
                >
                  <option>Mr.</option>
                  <option>Mrs.</option>
                  <option>Miss</option>
                </Input>
              </FormGroup>
            </Col>
            <Col md="3">
              <FormGroup>
                <label for="firstName">First Name *</label>
                <Input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
            </Col>
            <Col md="3">
              <FormGroup>
                <label for="surname">Surname *</label>
                <Input
                  type="text"
                  id="surname"
                  name="surname"
                  value={formData.surname}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
            </Col>
            <Col md="3">
              <FormGroup>
                <label for="contactMobile">Contact Mobile *</label>
                <Input
                  type="text"
                  id="contactMobile"
                  name="contactMobile"
                  value={formData.contactMobile}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
            </Col>
            <Col md="4">
              <FormGroup>
                <label for="emailAddress">Email Address *</label>
                <Input
                  type="email"
                  id="emailAddress"
                  name="emailAddress"
                  value={formData.emailAddress}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
            </Col>
            <Col md="4">
              <FormGroup>
                <label for="address">Address *</label>
                <Input
                  type="text"
                  id="address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
            </Col>
            <Col md="4">
              <FormGroup>
                <label for="postCode">Post Code *</label>
                <Input
                  type="text"
                  id="postCode"
                  name="postCode"
                  value={formData.postCode}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
            </Col>
          </Row>

        

          {/* Row 7 */}
          <Row>
            <Col md="6">
              <FormGroup>
                <label for="departTerminal">Departure Terminal *</label>
                <Input
                  type="text"
                  id="departTerminal"
                  name="departTerminal"
                  value={formData.departTerminal}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <label for="departFlight">Departure Flight *</label>
                <Input
                  type="text"
                  id="departFlight"
                  name="departFlight"
                  value={formData.departFlight}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
            </Col>
          </Row>

          {/* Vehicle Details */}
          <Row>
            <Col md="3">
              <FormGroup>
                <label for="make">Make *</label>
                <Input
                  type="text"
                  id="make"
                  name="make"
                  value={formData.make}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
            </Col>
            <Col md="3">
              <FormGroup>
                <label for="model">Model *</label>
                <Input
                  type="text"
                  id="model"
                  name="model"
                  value={formData.model}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
            </Col>
            <Col md="3">
              <FormGroup>
                <label for="colour">Colour *</label>
                <Input
                  type="text"
                  id="colour"
                  name="colour"
                  value={formData.colour}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
            </Col>
            <Col md="3">
              <FormGroup>
                <label for="registration">Registration *</label>
                <Input
                  type="text"
                  id="registration"
                  name="registration"
                  value={formData.registration}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
            </Col>
          </Row>

       
          {/* Additional fields follow the same structure */}
          <Row>
          
            <Col md={6}>
            <FormGroup check>
                                <label check>
                                  <Input
                                    type="checkbox"
                                    name="sendCustomerEmail"
                                    checked={formData.sendCustomerEmail }
                onChange={handleChange}
                                  />{" "}
                                 Send Customer Confirmation Email
                                </label>
                              </FormGroup></Col>
                             <Col md={6}>
                             <FormGroup check>
                                <label check>
                                  <Input
                                    type="checkbox"
                                    name="sendCompanyEmail"
                                    checked={formData.sendCompanyEmail}
                                    onChange={handleChange}
                                  />{" "}
                                  Send Company Confirmation Email
                                </label>
                              </FormGroup></Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="warning" type="submit">
            Amend Booking
          </Button>
          <Button color="danger" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default AmendBookingModal;
